import { Table, tableFromArrays } from "apache-arrow";

export interface WeekStats {
  ab: number[];
  run: number[];
  hit: number[];
  hr: number[];
  rbi: number[];
  sb: number[];
  bb: number[];
  avg: number[];
  obp: number[];
  slg: number[];
}

export interface SeasonData {
  teams: string[];
  weeks: { week: number; stats: WeekStats }[];
}

export function loadSeasonData(data: SeasonData): Table[] {
  return data.weeks.map((w) =>
    tableFromArrays({
      team: data.teams,
      ab: new Uint32Array(w.stats.ab),
      run: new Uint32Array(w.stats.run),
      hit: new Uint32Array(w.stats.hit),
      hr: new Uint32Array(w.stats.hr),
      rbi: new Uint32Array(w.stats.rbi),
      sb: new Uint32Array(w.stats.sb),
      bb: new Uint32Array(w.stats.bb),
      avg: new Float32Array(w.stats.avg),
      obp: new Float32Array(w.stats.obp),
      slg: new Float32Array(w.stats.slg),
    })
  );
}
